<template>
	<b-card no-body class="p-3" :class="!_gHlp.isEmpty(currentStatus) ? currentStatus.color_class + '-border' : ''"
		v-if="!_gHlp.isEmpty(activeCase)">
		<DrawerRepayment ref="drawer_repayment_list" />
		<b-row>
			<b-col lg="auto" align-self="center">
				<div class="d-flex">
					<el-dropdown trigger="click" v-model="coll_status_id" style="cursor: pointer;"
						@command="updateStatusCollection">
						<p class="el-dropdown-link top-line">
							<span class="d-inline-block text-truncate" style="max-width: 150px; overflow: unset;"
								:class="currentStatus.color_class">{{ currentStatus.name }}</span>
							<i class="el-icon-caret-bottom el-icon--right"></i>
						</p>
						<el-dropdown-menu slot="dropdown">
							<div style="max-height: 300px;overflow-y: auto;">
								<el-dropdown-item v-for="(status, index) in statusList" :key="index" :command="status">{{ status.name
									}}</el-dropdown-item>
							</div>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</b-col>
			<b-col class="border-left">
				<p class="text-xs">Due Date (Days Left)</p>
				<el-popover
					placement="top"
					width="300"
					trigger="click">
					<b-form-group label="Due Date">
							<el-date-picker
							v-model="form.coll_due_date"
							value-format="yyyy-MM-dd"
							type="date"
							placeholder="Pick a day"
							@change="updateCollDueDate"
							>
							</el-date-picker>
					</b-form-group>
					<div slot="reference" class="d-flex align-items-start cursor-pointer">
						<p class="font-weight-600 mr-2"><u>{{ activeCase.coll_due_date | dateFormatString }}</u></p>
						<div class="text-warning">
							<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512">
								<path fill="currentColor"
									d="M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-24 120v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
							</svg>
							<span class="ml-1 text-xs">{{ _gHlp.getValue(activeCase,'overdue_repayment.late_days',0) }}d</span>
						</div>
					</div>
				</el-popover>
				<i>First Due Date : {{ activeCase.repay_first_due_date }}</i>
			</b-col>
			<b-col>
				<div class="d-flex align-items-center">
					<p class="text-xs">Next Repayment</p>
					<div class="d-flex align-items-center cursor-pointer text-primary ml-2"
						@click="$refs.drawer_repayment_list.show()">
						<p class="text-xs text-primary mr-1">Details</p>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="20" viewBox="0 0 320 512">
							<path fill="currentColor"
								d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256L73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
						</svg>
					</div>
				</div>
				<h4>{{ activeCase.coll_next_payment_amt | moneyFormatter }}</h4>
			</b-col>
			<b-col>
				<p class="text-xs">Total Paid Amt.</p>
				<h4>{{ activeCase.coll_total_paid_amt | moneyFormatter }}</h4>
			</b-col>
			<b-col>
				<p class="text-xs">Outstanding Balance</p>
				<h4>{{ activeCase.coll_outstanding_bal | moneyFormatter }}</h4>
			</b-col>
			<b-col cols="auto" align-self="center">
				<el-dropdown trigger="click" style="cursor: pointer">
					<p class="el-dropdown-link mb-0 top-line">
						<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
					</p>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>
							<!-- Eye Icon -->
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
								<path fill="#13663E"
									d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
							</svg>
							View Change Log
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</b-col>
		</b-row>
	</b-card>
</template>
<script>
import { DropdownMenu, DropdownItem, Dropdown, Popover, DatePicker, Button } from 'element-ui'
import { swal } from '@/assets/js/httpImports.js';
import {cloneDeep} from 'lodash'
import DrawerRepayment from '@/views/CreditLoanCase/Drawers/DrawerRepayment'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
import { useCommonStore } from '@/stores/commonStore'
import { useApprovalStore } from '@/stores/approvalStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMessagingStore } from '@/stores/messagingStore';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import moment from 'moment'

export default {
	components: {
		DrawerRepayment,
		[Button.name]: Button,
		[DatePicker.name]: DatePicker,
		[Popover.name]: Popover,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	props: ['collection'],
	data() {
		return {
			currentStatus: {},
			statusList: [],
			coll_status_id: null,
			form:{
				coll_due_date:''
			}
		}
	},
	created() {
		gEventBus.$on('refresh-collection-sum', this.refresh)
		this.setStatusList();
	},
	beforeDestroy() {
		gEventBus.$off('refresh-collection-sum', this.refresh)
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		...mapState(useCommonStore, ['allStatus'])
	},
	watch: {
		'activeCase': {
			handler(newValue, oldValue) {
				this.setStatusList()
				if(!_gHlp.isEmpty(newValue)){
					this.form.coll_due_date = cloneDeep(newValue.coll_due_date)
				}
			},
			immediate: true
		},
		'allStatus': {
			handler(newValue, oldValue) {
				this.setStatusList()
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useApprovalStore, ['createApproval']),
		...mapActions(useLoanCaseStore, ['getCase']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		refresh(){
			this.getCase().then(resp => {
				this.setStatusList();
			});
		},
		setStatusList() {
			if (!_gHlp.isEmpty(this.allStatus)) {
				this.statusList = this.allStatus.filter(itm => itm.module == 'collection');
				this.setCurrentStatus();
			}
		},
		setCurrentStatus() {
			if (!_gHlp.isEmpty(this.allStatus) && !_gHlp.isEmpty(this.activeCase)) {
				this.coll_status_id = this.activeCase.coll_status_id;
				this.currentStatus = this.allStatus.find(itm => itm.id == this.coll_status_id);
			}
			if (_gHlp.isEmpty(this.currentStatus)) {
				this.currentStatus = { id: null, name: "No Status", color_class: "text-grey" }
			}
		},
		updateStatusCollection(status) {
			let status_name = status.name;
			let status_id = status.id;
			swal.fire({
				title: 'Status Change',
				text: "Confirm change to " + status_name,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					const params = {
						table_name: 'loan_case',
						table_key: 'case_id',
						table_id: this.activeCase.case_id,
						data_reject: null,
						data_approve: {
							coll_status_id: status_id
						},
						message: 'Pending Approval : Collection change status to <b>"' + status_name + '</b>" by credit officer ' + _gAuth.activeUser('name', ''),
						approve_type: 'Collection Approval',
						custom_key: 'CASE_' + this.activeCase.case_id,
						approve_status: 'Pending',
						submit_at: _gHlp.getCurrentDateTime(),
						submit_by: _gAuth.activeUser('id', null)
					}
					this.createApproval(params).then(res => {
						this.createBellNotif('LMS_CASE_COLLECTION_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
						this.createSendEmail('LMS_CASE_COLLECTION_REQUEST',{case_id:this.activeCase.case_id, customer_name:this.activeCase.name })
						gEventBus.$emit('refresh-approval')
						_gNotif.notifySuccess('<b>Collection: </b> - Status change submitted. Pending Approval for <b>""' + status_name + '""</b> status');
						this.is_loading = false;
					}).catch(err => {
						this.is_loading = false;
					});
				}
			})
		},
		updateCollDueDate() {
			let due_date = this.form.coll_due_date;
			if(_gHlp.isEmpty(due_date)) return false;
			
			swal.fire({
				title: 'Due Date Change',
				text: "Confirm change to " + due_date,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading = true;
					const params = {
						table_name: 'loan_case',
						table_key: 'case_id',
						table_id: this.activeCase.case_id,
						data_reject: null,
						data_approve: {
							coll_due_date: _gHlp.formatDate(due_date)
						},
						message: 'Pending Approval : Collection due date change to <b>"' + due_date + '</b>" by ' + _gAuth.activeUser('name', ''),
						approve_type: 'Change Due Date',
						custom_key: 'CASE_' + this.activeCase.case_id,
						approve_status: 'Pending',
						submit_at: _gHlp.getCurrentDateTime(),
						submit_by: _gAuth.activeUser('id', null)
					}
					this.createApproval(params).then(res => {
						this.createBellNotif('',{
								due_date:due_date,
								case_id:this.activeCase.case_id,
								customer_name:this.activeCase.name,
								noti_url: window.location.origin +'/credit-loan-case/detail/'+this.activeCase.case_id+'?active=collection',
								noti_related_type: 'loan_case',
								noti_related_id: this.activeCase.case_id
						},
						'Collection: customer {customer_name} request change due date to {due_date} by {user_name}')

						gEventBus.$emit('refresh-approval')
						_gNotif.notifySuccess('<b>Collection: </b> - Approval request for change due date has been submitted.');
						this.is_loading = false;
					}).catch(err => {
						this.is_loading = false;
					});
				}
			})
		},

	}
}
</script>